module.exports = __webpack_public_path__ + "img/vip_only_kr2.b845f055.png";